<template>
    <div id="footer_n" class="row footer-background" :class="[ loadingPage ? 'mt-50' : '',  {'bg-footer': getTemplateId == 2} ]">
        <div class="col-12 d-flex justify-content-center">
            <div class="row py-5 width-n">
                <!-- Logo, Sobre Nosotros -->
                <div :class="[{ 'pl-0': !isMobile }, classLogo]">
                    <div class="row">
                        <div class="col-12">
                            <img :src="footerLogo" alt="Logo" width="235" v-if="footerLogo">

                            <h1 v-else>- Logo -</h1>
                        </div>

                        <app-contact-us-info-c
                            class="mt-4 ml-3"
                            v-if="getTemplateId == 2"
                            :data="contactUsInfo"
                            :template-id="getTemplateId"
                        >
                        </app-contact-us-info-c>

                        <template
                            v-else
                        >
                            <div class="col-12 fs-24 mt-4">
                                <strong>{{ ecommerceName }}</strong>
                            </div>

                            <div class="col-12 fs-18" v-html="aboutUsSummary">
                            </div>

                            <div class="col-12 fs-18" v-if="aboutUsSummary">
                                <br>
                                <inertia-link class="a-white-s-underline" href="/about-us">Conozca más sobre nosotros...</inertia-link>
                            </div>
                        </template>

                    </div>
                </div>

                <!-- Datos Contacto -->
                <div class="col-md-4">
                    <app-contact-us-info-c
                        v-if="getTemplateId == 1"
                        :data="contactUsInfo"
                        :template-id="getTemplateId"
                    >
                    </app-contact-us-info-c>

                    <div class="row fs-18 mt-4">
                        <div class="col-12 fs-24 mb-2">
                            <h3 :class="{'title-footer': getTemplateId == 2}">Información legal</h3>
                        </div>

                        <div class="col-12">
                            <inertia-link class="a-white-s-underline" href="/processing-of-personal-data">Tratamiento de datos personales</inertia-link>
                        </div>

                        <div class="col-12">
                            <inertia-link class="a-white-s-underline" href="/terms-and-conditions">Términos y condiciones</inertia-link>
                        </div>

                        <div class="col-12">
                            <inertia-link class="a-white-s-underline" href="/shipping-policies">Políticas de envío</inertia-link>
                        </div>

                        <div class="col-12">
                            <a class="a-white-s-underline" href="https://www.sic.gov.co/" target="_blank">Superintendencia de Industria y Comercio - SIC</a>
                        </div>
                    </div>
                </div>

                <!-- Formulario de contacto -->
                <div class="col-md-4" :class="{ 'pr-0': !isMobile }" v-if="showContactUsForm">
                    <app-contact-us-c></app-contact-us-c>
                </div>
            </div>
        </div>

        <div class="col-12 fs-20 py-4 text-center footer-nilo-section">
            <p>Potenciado por:</p>
            <img class="ml-3 mr-1" src="/img/logo-icono-blanco.png" alt="logo-nilo"> <span class="fw-200"><strong>Nilo</strong> App | <a class="a-white-s" href="https://nilo.app/">www.nilo.app</a></span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import fileRootPathMixin from '../../../mixins/fileRootPathMixin';

import AppContactUsC from '../ContactUs/ContactUsComponent.vue';
import AppContactUsInfoC from './ContactUsInfoComponent.vue';

export default {

    components: {

        AppContactUsC,
        AppContactUsInfoC,

    },

    mixins: [fileRootPathMixin],

    data() {

        return {

            loadingPage: true,

            // Logos
            footerLogo: null,

            // About Us
            aboutUsSummary: null,

            // Contacto
            ecommerceName: null,

            contactUsInfo: {
                mainPhone: null,
                secondaryPhone: null,
                contactEmail: null,
                address: null,
                facebook: null,
                instagram: null,
                twitter: null,
                youtube: null,
                linkedin: null,
            },

            showContactUsForm: false,

            classLogo: null,
            classContactUs: null,

        };

    },

    computed: {
        ...mapGetters([

            'getTemplateId',

        ]),
    },

    mounted() {

        this.loadFooterLogo();
        this.loadCompanyData();
        this.loadContactUsForm();
        this.loadSocialNetworks();

        // Timeout para controlar el flash de mostrar primero el footer
        setTimeout(() => {

            this.loadingPage = false;

        }, 200);

    },

    methods: {

        loadFooterLogo() {

            const logos = $.parseJSON(localStorage.getItem('logos'));

            if (logos && logos.length > 0) {

                const footerLogo = logos.find((logo) => logo.position == 2);

                if (footerLogo) {

                    this.footerLogo = this.fileRootPath + footerLogo.path;

                }

            }

        },

        loadCompanyData() {

            const companyData = $.parseJSON(localStorage.getItem('company_data'));

            if (companyData) {

                this.ecommerceName = companyData.ecommerce_name;
                this.contactUsInfo.mainPhone = companyData.main_phone;
                this.contactUsInfo.secondaryPhone = companyData.secondary_phone;
                this.contactUsInfo.contactEmail = companyData.contact_email;
                this.contactUsInfo.address = companyData.address;

            }

            const aboutUsSummary = localStorage.getItem('about_us_summary');

            if (aboutUsSummary && aboutUsSummary != 'null') {

                this.aboutUsSummary = aboutUsSummary;

            }

        },

        loadContactUsForm() {

            const contactUsForm = $.parseJSON(localStorage.getItem('contact_us_form_active'));

            this.showContactUsForm = contactUsForm;

            if (contactUsForm) {

                this.classLogo = 'col-md-4';

                this.classContactUs = 'col-md-4';

            } else {

                this.classLogo = 'col-md-6';

                this.classContactUs = 'col-md-6';

            }

        },

        loadSocialNetworks() {

            const socialNetworks = $.parseJSON(localStorage.getItem('social_networks'));

            if (socialNetworks) {

                this.contactUsInfo.facebook = socialNetworks.facebook ? `https://www.facebook.com/${socialNetworks.facebook}` : null;
                this.contactUsInfo.twitter = socialNetworks.twitter ? `https://twitter.com/${socialNetworks.twitter}` : null;
                this.contactUsInfo.youtube = socialNetworks.youtube ? `https://www.youtube.com/${socialNetworks.youtube}` : null;
                this.contactUsInfo.instagram = socialNetworks.instagram ? `https://www.instagram.com/${socialNetworks.instagram}` : null;
                this.contactUsInfo.linkedin = socialNetworks.linkedin ? `https://www.linkedin.com/${socialNetworks.linkedin}` : null;

            }

        },

    },

};
</script>
